/**
 * Product card swatch interaction.
 * Swaps card image when a color swatch is clicked, marks the active swatch
 * with `.is-active`, and rewrites all anchor links to point to the matching
 * variant URL.
 */
document.addEventListener("click", (e) => {
  const swatch = e.target.closest("[data-swatch]");
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest("[data-product-card]");
  if (!card) return;

  const img = card.querySelector(".product-card-image");
  if (img && swatch.dataset.imageSrc) {
    img.src = swatch.dataset.imageSrc;
    if (swatch.dataset.imageSrcset) img.srcset = swatch.dataset.imageSrcset;
  }

  if (swatch.dataset.url) {
    card.querySelectorAll("a").forEach((a) => (a.href = swatch.dataset.url));
  }

  card
    .querySelectorAll("[data-swatch]")
    .forEach((s) => s.classList.remove("is-active"));
  swatch.classList.add("is-active");
});
